import { connect }          from 'react-redux';
import Rules                from './rules.jsx';
import { requestRulesText } from './rules-dux';
import Errors               from '../../../errors';
import { dismissError }     from '../../../errors-dux';

export default connect(
    // mapStateToProps
    ( state ) => {
      return {
            authenticated: state.userData.authenticated,
            busy: state.rulesData.busy || false,
            errors: Errors.getByType( state, Errors.ERROR_EXPORT_RULES_FAILED ),
            rulesText: state.rulesData.rulesText,
            participantRules: ( state.userData.participantRules || [] ).sort( ( a, b ) => a.programName.localeCompare( b.programName ) )
        };
    },
    // mapDispatchToProps
    {
        requestRulesText,
        dismissError
    }
)( Rules );
